export default __webpack_public_path__ + "static/media/logo.6d5c7917.svg";